const experience = [
  {
    id: 'major-ai-ml-iit-ropar',
    title: 'Major in AI/ML',
    company: 'IIT Ropar',
    description: 'Pursuing an AI/ML major training track focused on model development, evaluation, and practical machine learning implementation.',
    technologies: ['AI', 'Machine Learning', 'Model Evaluation', 'Deep Learning Basics'],
    period: '2024 - 2026 (Finished)',
    type: 'Education',
    orderIndex: 0,
  },
  {
    id: 'btech-data-science-giet',
    title: 'B.Tech in Data Science',
    company: 'GIET University',
    description: 'Pursuing B.Tech in Data Science since 2024 with a focus on statistics, machine learning foundations, and applied analytics.',
    technologies: ['Data Science', 'Statistics', 'Python', 'Machine Learning'],
    period: '2024 - Present',
    type: 'Education',
    orderIndex: 0,
  },
  {
    id: 'mern-full-stack-iit-ropar',
    title: 'MERN Full Stack',
    company: 'IIT Ropar',
    description: 'Completed intensive full-stack training covering MongoDB, Express.js, React, and Node.js to build scalable web applications.',
    technologies: ['React', 'Node.js', 'Express', 'MongoDB'],
    period: '2026',
    type: 'Internship',
    orderIndex: 1,
  },
  {
    id: 'stock-market-analyst',
    title: 'Stock Market Analyst',
    company: 'Launched Global',
    description: 'Worked on equity research and market trend analysis using technical indicators on real market data. SEBI certified.',
    technologies: ['Technical Analysis', 'Financial Data'],
    period: '2025',
    type: 'Internship',
    orderIndex: 2,
  },
  {
    id: 'rpa-developer-associate',
    title: 'RPA Developer Associate',
    company: 'EduSkill (UiPath)',
    description: 'Completed hands-on RPA training with UiPath Studio and built automated workflows for business process optimization.',
    technologies: ['UiPath', 'Automation', 'Business Process'],
    period: '2026',
    type: 'Training',
    orderIndex: 3,
  },
  {
    id: 'ui-ux-design-eduskill',
    title: 'Professional UI/UX Design & Web Prototyping',
    company: 'EduSkill',
    description: 'Specialized internship in modern interface design, user experience optimization, and rapid web prototyping. (Grade O)',
    technologies: ['UI/UX', 'Figma', 'Prototyping', 'Web Design'],
    period: '2026',
    type: 'Internship',
    orderIndex: 4,
  },
  {
    id: 'prompt-engineering-ai-eduskill',
    title: 'Prompt Engineering for AI',
    company: 'EduSkill Academy',
    description: 'Internship focused on optimizing AI interactions, context engineering, and deploying large language models for practical applications.',
    technologies: ['Prompt Engineering', 'AI', 'LLMs', 'Context Optimization'],
    period: '2026',
    type: 'Internship',
    orderIndex: 5,
  },
];

export default experience;
